module.exports = __webpack_public_path__ + "Flag-266.b568865f0785a3fd619e56936e217b8b.svg";